import { GetListResult } from "react-admin";
import axios from "axios";
import HttpClient from "../HttpClient";

export class DishCategoryTagService {
    async getAllTags(): Promise<GetListResult<any>> {
        const res = await HttpClient.get("/cuisine/dish-category-tags");
        const data = res?.data ?? [];
        return {
            data,
            total: data.length,
        };
    }

    async getTagById(tagId: number): Promise<any> {
        const res = await HttpClient.get(`/cuisine/dish-category-tags/${tagId}`);
        return { data: res?.data };
    }

    async createTag(payload: any): Promise<any> {
        const res = await HttpClient.post("/cuisine/dish-category-tags", payload);
        return { data: res?.data };
    }

    async updateTag(tagId: number, payload: any): Promise<any> {
        const res = await HttpClient.patch(`/cuisine/dish-category-tags/${tagId}`, payload);
        return { data: res?.data };
    }

    async getDishesForTag(tagId: number): Promise<any[]> {
        const res = await HttpClient.get(`/cuisine/dish-category-tags/${tagId}/dishes`);
        return res?.data ?? [];
    }

    async getAWSLinks(imageName: string) {
        const payload = {
            directory: "dishCategoryIcons",
            fileName: imageName,
        };
        const data = await HttpClient.get("uploadImage/getSignedUrl", {
            params: payload,
        });
        return data?.data;
    }

    async uploadImageToAWS(url: string, binaryImage: File | Blob) {
        const response = await axios.put(url, binaryImage);
        return response;
    }
}
